// 首页
export default {
    displayInfo: 'Display Information',
    user: 'User',
    pleaseEnterId: 'Please enter device SN',
}